module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/logo_c03-c4288a2196f5bdfa248faa5ddbd9109d.jpg";